document.addEventListener('DOMContentLoaded', () => {
  const questionBtns = document.querySelectorAll('.opcion--3q');
  const containers = document.querySelectorAll('.tqContainer');

  questionBtns.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      questionBtns.forEach(b => b.classList.remove('active'));
      containers.forEach(c => c.classList.remove('selected'));
      
      btn.classList.add('active');
      containers[index].classList.add('selected');
    });
  });
});